/**
 * Labstep
 *
 * @module components/Experiment/Info
 * @desc Experiment Info as Table
 */

import { EntityLink } from 'labstep-web/components/Entity/Link';
import { ExperimentFormShowEditDates } from 'labstep-web/components/Experiment/Form/ShowEdit/Dates';
import { HorizontalTable } from 'labstep-web/core/Table/Horizontal';
import type { Experiment } from 'labstep-web/models/experiment.model';
import type React from 'react';
import type { ExperimentInfoProps } from './types';

export const getRows = (experiment: Experiment) => {
  const rows = [
    {
      header: 'Version used in',
      content: () => (
        <EntityLink
          dataCy="components/Experiment/Info:versionUsedIn"
          entity={experiment.experiment_workflow}
          showIcon
          secondary
        />
      ),
    },
  ];
  if (experiment.protocol) {
    rows.push({
      header: 'Based on',
      content: () => (
        <EntityLink
          dataCy="components/Experiment/Info:basedOn"
          entity={experiment.protocol}
          displayName={experiment.protocol.nameAndVersion}
          showIcon
          secondary
        />
      ),
    });
  }

  if (experiment.started_at && !experiment.isTemplate) {
    rows.push({
      header: 'Dates',
      content: () => (
        <ExperimentFormShowEditDates experiment={experiment} />
      ),
    });
  }

  return rows;
};

export const ExperimentInfo: React.FC<ExperimentInfoProps> = ({
  experiment,
}) => (
  <HorizontalTable
    data-cy="components/Experiment/Info"
    borderless
    headerProps={{ width: 3 }}
    rows={getRows(experiment)}
    columns={[experiment]}
  />
);
